import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import InstallBatteryImg from '../assets/install-battery.svg?react';
import PlugInTerminalImg from '../assets/plug-in-terminal.svg?react';
import TurnTerminalOnImg from '../assets/turn-on-terminal.svg?react';
import { RegisterTerminalModalStripeSteps } from '../hooks';
import {
  RegisterTerminalModalStepProps,
  RegisterTerminalStepModalWrapper,
  RegisterTerminalStep,
} from '../register-terminal-modal-step';

const styles = {
  list: css`
    list-style-type: number;
    padding-left: ${theme.spacing(2)};
    margin-top: ${theme.spacing(2)};
    margin-bottom: ${theme.spacing(1)};
  `,
};

export const InstallBattery = (props: RegisterTerminalModalStepProps) => {
  const { t } = useTranslation('payments');

  return (
    <RegisterTerminalStepModalWrapper
      title={t('Install battery')}
      nextStep={RegisterTerminalModalStripeSteps.PlugInTerminal}
      nextSectionStep={RegisterTerminalModalStripeSteps.ConnectToNetwork}
      Action={RegisterTerminalStep.Next}
      goBack={false}
      {...props}
    >
      <InstallBatteryImg />
      <ol css={styles.list}>
        <li>
          {t(
            'Install the battery by lifting up the back cover from the indentation at the bottom left. Slide the battery into the exposed slot and align the gold connectors at the top of the battery with the terminal.'
          )}
        </li>
      </ol>
    </RegisterTerminalStepModalWrapper>
  );
};

export const PlugInTerminal = (props: RegisterTerminalModalStepProps) => {
  const { t } = useTranslation('payments');

  return (
    <RegisterTerminalStepModalWrapper
      title={t('Charge terminal in its cradle')}
      nextStep={RegisterTerminalModalStripeSteps.TurnTerminalOn}
      nextSectionStep={RegisterTerminalModalStripeSteps.ConnectToNetwork}
      Action={RegisterTerminalStep.Next}
      {...props}
    >
      <PlugInTerminalImg />
      <ol css={styles.list} start={2}>
        <li>
          {t(
            "Charge the terminal in it's cradle. Alternatively, you can connect the reader to power by plugging the provided power cable into the port with the lightning bolt symbol."
          )}
        </li>
      </ol>
    </RegisterTerminalStepModalWrapper>
  );
};

export const TurnTerminalOn = (props: RegisterTerminalModalStepProps) => {
  const { t } = useTranslation('payments');

  return (
    <RegisterTerminalStepModalWrapper
      title={t('Turn the terminal on')}
      nextStep={RegisterTerminalModalStripeSteps.ConnectToNetwork}
      Action={RegisterTerminalStep.Continue}
      {...props}
    >
      <TurnTerminalOnImg />
      <ol css={styles.list} start={3}>
        <li>
          {t(
            'Once charged, find and hold down the Power button on the right side of the terminal until the terminal screen turns on.'
          )}
        </li>
      </ol>
    </RegisterTerminalStepModalWrapper>
  );
};
